import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import { BoxStyled, BoxTitle, BoxContent, BoxWrapperLink, BoxWrapperHref, BoxItem, BoxItemText, BoxItemBottomText, StyledIcon } from './styled'

const BoxWrapper = ({ children, to, href, active, bordercolor }) => {
  if (href) {
    return (
      <BoxWrapperHref href={href} active={active ? 1 : 0} bordercolor={bordercolor}>
        {children}
      </BoxWrapperHref>
    )
  }
  return (
    <BoxWrapperLink to={to} active={active ? 1 : 0} bordercolor={bordercolor}>
      {children}
    </BoxWrapperLink>
  )
}

const Box = ({ title, content, to, withWarnings, warning, alarm, active, bordercolor, icon, info, autoHeightContent, noMarginConent, href }) => {
  return (
    <BoxStyled>
      <BoxWrapper to={to} href={href} active={active ? 1 : 0} bordercolor={bordercolor}>
        <BoxTitle active={active} title={title}>{title}</BoxTitle>
        {
          active ?
            <BoxContent autoHeightContent={autoHeightContent} noMarginConent={noMarginConent}>
              {
                content
              }
              {
                (warning > 0) &&
                <BoxItem>
                  <Icon name='bell' />
                  <BoxItemText>{warning}</BoxItemText>
                </BoxItem>
              }
              {
                (alarm > 0) &&
                <BoxItem>
                  <Icon name='alert' />
                  <BoxItemText>{alarm}</BoxItemText>
                </BoxItem>
              }
              {
                (alarm === 0 && warning === 0) &&
                <BoxItem>
                  <BoxItemBottomText>
                    {info}
                  </BoxItemBottomText>
                </BoxItem>
              }
            </BoxContent>
            :
            <BoxContent>
              {icon && (
                <BoxItem>
                  <StyledIcon name={icon} height="34" width="34" />
                </BoxItem>
              )}
              {withWarnings && (
                <BoxItem>
                  <StyledIcon name='bell' />
                </BoxItem>
              )}
              {withWarnings && (
                <BoxItem>
                  <StyledIcon name='alert' />
                </BoxItem>
              )}
            </BoxContent>
        }
      </BoxWrapper>
    </BoxStyled>
  )
}

Box.propTypes = {
  title: PropTypes.string,
  content: PropTypes.any,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  warning: PropTypes.number,
  alarm: PropTypes.number,
  active: PropTypes.bool,
  info: PropTypes.string,
  autoHeightContent: PropTypes.bool,
  noMarginConent: PropTypes.bool
};

Box.defaultProps = {
  title: "Title",
  content: "",
  to: "/",
  warning: null,
  alarm: null,
  active: false,
  info: '',
  autoHeightContent: false,
  noMarginConent: false
};

export default Box;